import { CITIES_BY_NAME_URL, CITY_STATE_REGEXP } from '@/constants';
import { UnauthorizedError, UnexpectedError } from '@/services';
import { CityByNameModel, CityModel } from '@/types';
import { HttpStatusCode, fromBff, httpClient } from '@/utils';

const handleResult = (data: CityByNameModel[]) => {
  if (!Boolean(data?.length)) return [];

  return data
    .map<CityModel>(({ description: place }) => {
      const result = CITY_STATE_REGEXP.exec(place);
      if (!result) return { place, name: '', stateAbbr: '' };
      const [, city, stateAbbr] = result;
      return { name: city, stateAbbr, place };
    })
    .filter((item) => Boolean(item.name) && Boolean(item.stateAbbr));
};

export const loadCitiesByNameService = async (name: string): Promise<CityModel[]> => {
  if (name.length < 2) return [];

  const { body, status } = await httpClient.get(fromBff(CITIES_BY_NAME_URL), { params: { city_name: name } });

  switch (status) {
    case HttpStatusCode.ok:
      return handleResult(body?.data);

    case HttpStatusCode.unauthorized:
      throw new UnauthorizedError();

    default:
      throw new UnexpectedError();
  }
};
